var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6795_27129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3604 6.20451C24.5071 4.81858 25.313 2.93625 25.2725 1.01897C25.2657 0.697005 24.972 0.457942 24.6536 0.506528C22.9713 0.763591 21.0906 1.81722 19.9265 3.18009C18.8536 4.42061 17.9015 6.34844 17.973 8.25876C17.9838 8.54662 18.227 8.77605 18.5149 8.7679C20.3718 8.71537 22.2051 7.60345 23.3604 6.20451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.322 26.7058C31.1563 26.1189 27.9392 24.0936 27.8994 19.6019C27.8654 15.925 30.3052 13.787 31.3431 13.0405C31.5895 12.8633 31.6436 12.5164 31.4563 12.2776C30.5939 11.1782 29.5856 10.4731 28.6169 10.016C28.6175 10.0159 28.6182 10.0157 28.6188 10.0157C28.4933 9.9564 28.2785 9.86233 28.1066 9.79462C23.2325 7.876 20.1609 10.8168 18.3002 10.8168C16.8756 10.8168 14.6773 9.20715 12.3481 9.2511C9.28747 9.29554 6.46836 11.0316 4.89006 13.7709C2.46863 17.9738 3.26717 23.7192 5.15373 28.1968C5.15373 28.1969 5.15366 28.1969 5.15366 28.1969C5.20196 28.3115 5.27888 28.4897 5.34301 28.6337C5.34308 28.6335 5.34308 28.6334 5.34315 28.6333C5.88969 29.8607 6.5154 30.9823 7.17458 31.9357C8.6882 34.1235 10.4939 36.5881 12.8664 36.4975C15.15 36.407 16.0133 35.0211 18.7729 35.0211C21.5308 35.0211 22.3087 36.4975 24.7232 36.4536C27.1812 36.407 28.7376 34.221 30.2409 32.0228C31.5639 30.0913 32.2939 28.2061 32.5864 27.3573C32.6735 27.1044 32.5611 26.8262 32.322 26.7058Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6795_27129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.6749bd02d89985fa2101f5128b85d39a.svg";
export { ForwardRef as ReactComponent };